import { modifier } from 'ember-modifier';

import { uniqueId } from 'webapp/utils/common';

import type DChartPrimaryPoint from 'webapp/d-chart/point/primary-point';

export const dataDataPoint = 'data-datapoint';

const DatapointRegistry = new Map<string, DChartPrimaryPoint>();

export const getDataPointById = (id: string): DChartPrimaryPoint | undefined => {
	return DatapointRegistry.get(id);
};

const exposeDatapoint = modifier((node: HTMLElement, [datapoint]: [DChartPrimaryPoint]) => {
	const id = uniqueId().toString();

	DatapointRegistry.set(id, datapoint);
	node.setAttribute(dataDataPoint, id);

	return () => {
		node.removeAttribute(dataDataPoint);
		DatapointRegistry.delete(id);
	};
});

export default exposeDatapoint;
